import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from './http.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public $buyerpromptFilter = new BehaviorSubject<any>(null);

  constructor(
    private httpService: HttpService,
    private router: Router,
  ) {}

  updateProfile(payload: any) {
    const formData = new FormData();
    for (let key in payload) {
      formData.append(key, payload[key]);
    }
    return this.httpService.post('v1/web/user/profile/update', formData);
  }
  updatesellerProfile(payload: any) {
    const formData = new FormData();
    for (let key in payload) {
      formData.append(key, payload[key]);
    }
    return this.httpService.post('v1/web/seller/profile/update', formData);
  }

  fetchSheetMaster(payload: any = {}) {
    return this.httpService.post('v1/web/seller/sheet/masterdata', payload);
  }

  fetchDispatchedSheet(payload: any = {}) {
    return this.httpService.post(
      'v1/web/seller/sheet/fetchdispatchedsheet',
      payload,
    );
  }

  createOfferSheet(payload: any) {
    return this.httpService.post('v1/web/seller/offersheet/add', payload);
  }

  fetchgarden(payload: any) {
    return this.httpService.post('v1/web/seller/fetch/garden', payload);
  }

  fetchsessionwiseSheets(payload: any) {
    return this.httpService.post(
      'v1/web/buyer/fetch/sessionwisesheets',
      payload,
    );
  }

  uploadExcelOfferSheetInvoice(payload: any) {
    return this.httpService.postFormData('v1/web/seller/excel/upload', payload);
  }
  sentbuyerCatalogue(payload: any) {
    return this.httpService.postFormData(
      'v1/web/buyer/catalogue/sentemail',
      payload,
    );
  }
  sendsellerCatalogue(payload: any) {
    return this.httpService.postFormData(
      'v1/web/seller/catalogue/sendemail',
      payload,
    );
  }
  uploadSellerCatalogue(payload: any) {
    return this.httpService.postFormData(
      'v1/web/seller/catalogue/upload',
      payload,
    );
  }
  uploadExcelComment(payload: any) {
    return this.httpService.postFormData(
      'v1/web/buyer/comment/upload',
      payload,
    );
  }
  downloadComment(payload: any) {
    return this.httpService.downloadData(
      'v1/web/buyer/comment/download',
      payload,
    );
  }

  uploadExcelABP(payload: any) {
    return this.httpService.postFormData(
      'v1/web/buyer/excel/abpupload',
      payload,
    );
  }

  customOfferSheetInvoiceSubmit(payload: any) {
    return this.httpService.post('v1/web/seller/offerivoice/save', payload);
  }

  fetchExcelOfferSheetPreview(payload: any) {
    return this.httpService.post('v1/web/seller/excel/fetch', payload);
  }

  fetchBuyers(payload: any) {
    return this.httpService.post('v1/web/seller/buyer/list', payload);
  }

  fetchSellers(payload: any) {
    return this.httpService.post('v1/web/buyer/seller/list', payload);
  }

  dispatchExcelOfferSheet(payload: any) {
    return this.httpService.post('v1/web/seller/offerivoice/add', payload);
  }

  sellerDispatchedOfferSheetFetch(payload: any) {
    return this.httpService.post('v1/web/seller/dispatch/sheet', payload);
  }

  sellerActiveOfferSheetFetch(payload: any) {
    return this.httpService.post('v1/web/seller/active/sheet', payload);
  }
  sellerActiveOfferSubSheetFetch(payload: any) {
    return this.httpService.post('v1/web/seller/active/subsheet', payload);
  }

  sellerClosedOfferSheetFetch(payload: any) {
    return this.httpService.post('v1/web/seller/closed/sheet', payload);
  }
  sellerClosedSubOfferSheetFetch(payload: any) {
    return this.httpService.post('v1/web/seller/closed/subsheet', payload);
  }
  getOfferSheetInfo(payload: any) {
    return this.httpService.post('v1/web/sheet/sheetdetails', payload);
  }
  getMyPurchase(payload: any) {
    return this.httpService.post('v1/web/buyer/my-purchase-data', payload);
  }
  getbuyerpromptSummary(payload: any) {
    return this.httpService.post('v1/web/fetch-prompt', payload);
  }
  getConsignment(payload: any) {
    return this.httpService.post('v1/web/buyer/consignment', payload);
  }
  getinvoiceDeatil(payload: any) {
    return this.httpService.post('v1/web/buyer/invoice-detail', payload);
  }
  getBillingAddress(payload: any) {
    return this.httpService.post('v1/web/buyer/billing-address', payload);
  }
  submitBillingAddress(payload: any) {
    return this.httpService.post(
      'v1/web/buyer/confirm-dispatch-billing',
      payload,
    );
  }
  checkABPCutOff(payload: any) {
    return this.httpService.post('v1/web/buyer/check-abp-cutoff', payload);
  }
  searchSheetInfo(payload: any) {
    return this.httpService.post('v1/web/sheet/search', payload);
  }
  getOfferSheetBidders(payload: any) {
    return this.httpService.post('v1/web/sheet/bidders', payload);
  }
  getSettings(payload: any) {
    return this.httpService.post('v1/web/settings', payload);
  }

  getOfferSheetInvoices(payload: any) {
    return this.httpService.post('v1/web/sheet/invoices', payload);
  }

  buyerOfferSheetAction(payload: any) {
    return this.httpService.post('v1/web/makereceive/sheet', payload);
  }

  buyerCloseSessionwiseSale(payload: any) {
    return this.httpService.post(
      'v1/web/buyer/fetch/buyerclosesessionwisesale',
      payload,
    );
  }

  buyerSheetFetch(payload: any) {
    return this.httpService.post('v1/web/statuswise/sheet', payload);
  }
  buyerClosedSheet(payload: any) {
    return this.httpService.post('v1/web/buyer/closed-sheet', payload);
  }
  sellerClosedSheet(payload: any) {
    return this.httpService.post('v1/web/seller/closed/all-sheet', payload);
  }
  catalogueFetch(payload: any) {
    return this.httpService.post('v1/web/catalogue/fetch', payload);
  }
  fetchsellerPrompt(payload: any) {
    return this.httpService.post('v1/web/fetch-seller-prompt', payload);
  }
  fetchsellerPromptDetail(payload: any) {
    return this.httpService.post('v1/web/seller-prompt-detail', payload);
  }
  fetchbattingOrder(payload: any) {
    return this.httpService.post('v1/web/seller-prompt-detail', payload);
  }
  fetchbuyersheetGroup(payload: any) {
    return this.httpService.post('v1/web/fetch-buyersheetGroup', payload);
  }
  fetchSellerPromptBuyerWise(payload: any) {
    return this.httpService.post('v1/web/seller-prompt-buyerwise', payload);
  }
  sellerowncatalogueFetch(payload: any) {
    return this.httpService.post('v1/web/seller/own/catalogue/list', payload);
  }
  sellerowncatalogueDetailFetch(payload: any) {
    return this.httpService.post('v1/web/seller/own/catalogue/view', payload);
  }
  sellercatalogueFetch(payload: any) {
    return this.httpService.post('v1/web/seller/catalogue/list', payload);
  }
  saleprogrammeFetch(payload: any) {
    return this.httpService.post('v1/web/buer/sales-programme', payload);
  }
  promptDateFetch(payload: any) {
    return this.httpService.post('v1/web/prompt-date/fetch', payload);
  }
  buyerSubSheetFetch(payload: any) {
    return this.httpService.post('v1/web/statuswise/sub-sheet', payload);
  }
  buyerAbpSwitch(payload: any) {
    return this.httpService.post('v1/web/abp/switch', payload);
  }
  buyerBEQUALPSwitch(payload: any) {
    return this.httpService.post('v1/web/bequalp/switch', payload);
  }

  fetchReportMaster() {
    return this.httpService.post('v1/web/masterdata/invoice', {});
  }

  checkServerValidTimezone(payload: any) {
    return this.httpService.post('v1/frontend/timezone/valid', payload);
  }
  submitCatalogue(payload: any) {
    return this.httpService.postFormMultiData(
      'v1/web/catalogue/create',
      payload,
    );
  }
  viewCatalogue(payload: any) {
    return this.httpService.post('v1/web/catalogue/view', payload);
  }
  viewSellerCatalogue(payload: any) {
    return this.httpService.post('v1/web/seller/catalogue/view', payload);
  }
  removeCatalogue(payload: any) {
    return this.httpService.post('v1/web/catalogue/remove', payload);
  }
  removesellerCatalogue(payload: any) {
    return this.httpService.post('v1/web/seller/catalogue/remove', payload);
  }
  createSearchSheet(payload: any) {
    return this.httpService.post('v1/web/push-sheet', payload);
  }
  ownBidList(payload: any) {
    return this.httpService.post('v1/web/buyer/own-bid-logs', payload);
  }
  markErrorSubmit(payload: any) {
    return this.httpService.post('v1/web/buyer/marked-error', payload);
  }
  fetchPromptDeatil(payload: any = {}) {
    return this.httpService.post('v1/web/buyer/prompt/detail', payload);
  }
  uploadBuyerPrompt(payload: any) {
    return this.httpService.postFormData('v1/web/buyer-prompt', payload);
  }
  buyerPromptSalewise(payload: any) {
    return this.httpService.post('v1/web/buyer-prompt/sale-wise', payload);
  }
  buyerPromptSummary(payload: any) {
    return this.httpService.post('v1/web/buyer-prompt/summary', payload);
  }
  buyerPromptSellerwise(payload: any) {
    return this.httpService.post('v1/web/buyer-prompt/seller-wise', payload);
  }
  buyerPromptBuyerwise(payload: any) {
    return this.httpService.post('v1/web/buyer-prompt/buyer-wise', payload);
  }
  buyerPromptDetail(payload: any) {
    return this.httpService.post('v1/web/buyer-prompt/detail', payload);
  }
  fetchbuyersellerList(payload: any) {
    return this.httpService.post('v1/web/buyer-seller-list', payload);
  }

  saveKeywordMapping(payload: any) {
    return this.httpService.post('v1/web/append-search-keyword', payload);
  }
}
